
import './css/Style.css';

function RenderSinoNotificacoes({ style_pagina_principal, NavDestacada }) {


    function f_call_goto_historico_notificacoes() {
        const url_pagina_notificacoes = '#/opc_gerais/notificacoes/historico_notificacoes';
        window.location.href = url_pagina_notificacoes;
    }

    const classe_icone = (
        style_pagina_principal ? 'icone_notificacao' : (
            !NavDestacada ? 'icone_notificacao_navbar_simples' : 'icone_notificacao_navbar_simples_2'
        )
    );

    const classe_texto = (
        style_pagina_principal ? 'qtd_notificacoes' : 'qtd_notificacoes_nav_bar_simples'
    );

    return (
        <section className='container_geral_sino_notificacoes_0x88' onClick={f_call_goto_historico_notificacoes}>
            <>
                <i className={classe_icone}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
            </>
        </section>
    )
}

export {
    RenderSinoNotificacoes
}